import {
  picturePreviewAdapter,
  videoPreviewAdapter,
} from '@/modules/pictures/helpers';
import { type ProductBySlugResponse } from '@/modules/product/aliases';
import {
  hasThumbnailFormats,
  toProductPicture,
  toProductVideo,
} from '@/modules/product/helpers/toProductMedia';
import { type Preview } from '@/modules/product/types';

type ProductMedia = {
  pictures?: ProductBySlugResponse['pictures'];
  videos?: ProductBySlugResponse['videos'];
};

/**
 * Builds a card preview from the product's cover image. Same rule as the
 * presentation API: the first picture, with the first video's thumbnail only
 * standing in for listings that have no pictures at all.
 */
export function getProductPreview({ pictures, videos }: ProductMedia): Preview {
  if (pictures?.length) {
    return picturePreviewAdapter(toProductPicture(pictures[0]));
  }

  const firstVideo = videos?.[0];
  const video = firstVideo ? toProductVideo(firstVideo) : undefined;

  return video && hasThumbnailFormats(video) ? videoPreviewAdapter(video) : {};
}
